import Songs from "../../components/Songs/Songs"

const SongsScreen = () => {
  return <Songs />;
}
export default SongsScreen